import React from 'react'
import { isBlank, find, each, flatten, values, sortBy } from 'lodash'

import Table from "UI/Table"
import Filters from "Features/Filters"

import { customerColumns, productColumns, assetColumns } from "./Columns"

const addToProductsList = (products, name, asset, family) => {
  const productObject = find(products, ['name', name])

  if (productObject) {
    productObject.assets.add(asset)
    productObject.family.add(family)
  } else {
    products.push({ name, family: new Set().add(family), assets: new Set().add(asset) })
  }
}

const groupAssetsByProduct = (assets) => {
  const products = []

  each(assets, (asset) => {
    const softwareValues = flatten(values(asset.software))

    each(softwareValues, (software) => addToProductsList(products, software.product, asset, software.family))

    if (isBlank(softwareValues)) { addToProductsList(products, 'No software found.', asset, 'Unknown') }
  })

  each(products, product => {
    product.assets = [...product.assets]
    product.family = [...product.family]
  })

  return sortBy(products, 'name')
}

const DetailsFilters = ({ filters, changeFilters }) => {

  return (
    <Filters />
  )
}

const DetailsTable = ({ assets }) => (
  <Table
    filterable
    columns={customerColumns}
    data={assets}
    getTdProps={(_state, rowInfo, column, _instance) => {
      if (column.id === "total_servers.value" && !rowInfo.original.total_servers.compliant) {
        return { style: { color: 'orange' } }
      }

      return {}
    }}
    SubComponent={({ original }) => {
      const products = groupAssetsByProduct(original.assets)

      return (<Table
        columns={productColumns}
        data={products}
        showPagination={false}
        defaultPageSize={products.length}
        SubComponent={({ original }) => (
          <Table
            columns={assetColumns(original)}
            data={[...original.assets]}
            showPagination={false}
            defaultPageSize={original.assets.length}
          />
        )}
      />)
    }}
  />
)

export { DetailsFilters, DetailsTable }
